<template>
  <a-card hoverable style="margin-bottom: 5px">
    <div
      v-if="
        (privilege.selectParentOffice === 'REQUIRED' ||
          privilege.selectParentOffice === 'OPTIONAL') &&
        detOffice.isNew
      "
    >
      <p class="REQUIRED">Qurumlar</p>
      <a-select
        v-model="detOffice.selectedParentOfficeId"
        placeholder="Zəhmət olmasa Qurum  seçin"
        @change="(e) => handleOfficeChange(e, detOffice)"
        show-search
        :filter-option="false"
        @search="handleOfficeSearch"
      >
        <a-select-option v-for="x in filteredOffices" :key="x.id">{{
          x.name
        }}</a-select-option>
      </a-select>
    </div>

    <!--       <a-button
        v-if="detOffice.clientId"
        style="position: absolute; right: 5px; top: 5px"
        type="danger"
        shape="rectangle"
        icon="close"
        @click="remove(detOffice)"
      ></a-button> -->

    <h2
      v-if="
        !detOffice.isNew &&
        detOffice.problemSubOffices &&
        detOffice.parentOffice
      "
      style="text-align: center"
    >
      {{
        detOffice.problemSubOffices.length > 0
          ? detOffice.problemSubOffices[0].office.name +
            " (" +
            detOffice.parentOffice.name +
            ")"
          : detOffice.parentOffice.name
      }}
    </h2>

    <div
      v-if="
        privilege.selectExecutor === 'REQUIRED' ||
        privilege.selectExecutor === 'OPTIONAL'
      "
      style="margin-bottom: 10px"
    >
      <div v-if="detOffice.timeFinished === undefined">
        <a-alert
          v-if="noExecutorWarning"
          :message="detOffice.executorInfoHead"
          description="Bu tapşırığa aid icraçı yoxdur"
          type="warning"
          showIcon
        />
      </div>

      <div v-else-if="detOffice.timeFinished">
        <a-alert
          :message="detOffice.executorInfoHead"
          :description="detOffice.delayTimeStr"
          type="error"
          showIcon
        />
      </div>

      <div v-else-if="!detOffice.timeFinished">
        <a-alert
          :message="detOffice.executorInfoHead"
          :description="detOffice.delayTimeStr"
          type="warning"
          showIcon
        />
      </div>
    </div>

    <div
      class="last-op"
      v-if="detOffice.lastOperation && detOffice.lastOperation.opUser"
    >
      <p>Əvvəlki əməliyyat</p>
      <p>
        {{ getOperationText(detOffice.lastOperation) }}
        <a-tooltip
          v-if="detOffice.lastOperation.note"
          :title="detOffice.lastOperation.note"
        >
          <a-icon type="message" />
        </a-tooltip>

        <a-button
          style="
            float: right;
            top: 0px;
            background-color: #fff;
            color: black;
            border-radius: 5px;
          "
          size="small"
          v-if="detOffice.lastOperation.files.length > 0"
          @click="showMediaFiles(detOffice.lastOperation.files, detOffice)"
        >
          Fayllara bax
        </a-button>
      </p>
    </div>

    <div
      v-if="!detOffice.isNew && !oneConfirmButton"
      style="margin-bottom: 10px"
    >
      <!-- <p>Qərar</p> -->

      <a-radio-group
        buttonStyle="solid"
        v-model="detOffice.selectedKey"
        @change="handleButtonChange($event, detOffice)"
        style="flex-wrap: wrap"
      >
        <div
          style="width: 50%; margin-bottom: 10px"
          v-for="button in detOffice.buttons"
          :key="button.id"
        >
          <a-radio-button
          class="graybutton"
    
            :value="button.id"
            :style="{
              width: '98%',
              backgroundColor: detOffice.selectedKey === button.id? '#00988A':'#999',
              color: 'white',
              'text-align': 'center',
              transition: 'all 200ms',
              transform:
                detOffice.selectedKey === button.id
                  ? 'scale(1.1) translateY(-2px)'
                  : 'none',
              boxShadow:
                detOffice.selectedKey === button.id
                  ? '0 10px 5px 0 rgba(0,0,0,0.2) !important'
                  : 'none',
            }"
          >
            {{ button.name }}
          </a-radio-button>
        </div>
      </a-radio-group>
    </div>

    <!-- <div
        v-if="
          detOffice.selectedAction &&
          (detOffice.selectedAction.selectParentOffice === 'REQUIRED' ||
            detOffice.selectedAction.selectParentOffice === 'OPTIONAL') &&
            (detOffice.selectedAction.dataRequirementStatus === 'NECESSARIES' ||
              detOffice.selectedAction.dataRequirementStatus === 'ALL')
        "
      >
        <p class="REQUIRED">İcraçı təşkilat</p>
        <a-select
          v-model="detOffice.selectedParentOfficeId"
          placeholder="Zəhmət olmasa icraçı təşkilat seçin"
          @change="e => handleOfficeChange(e, detOffice)"
          show-search
          :filter-option="false"
          @search="handleOfficeSearch"
        >
          <a-select-option v-for="x in myOffices" :key="x.id">{{
            x.name
          }}</a-select-option>
        </a-select>
      </div>-->

    <!-- <div
      v-if="
        ((privilege.selectCategory === 'REQUIRED' ||
          privilege.selectCategory === 'OPTIONAL') &&
        detOffice.selectedAction &&
        (detOffice.selectedAction.dataRequirementStatus === 'NECESSARIES' ||
          detOffice.selectedAction.dataRequirementStatus === 'ALL'))
      "
      
      style="margin-bottom: 10px"
    >
    
      <p :class="privilege.selectCategory">Təsnifat</p>
      <a-tree-select
        v-model="detOffice.selectedCategoryUUID"
        style="width: 100%"
        allow-clear
        @change="handleCatChange"
        tree-default-expand-all
        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
        placeholder="Təsnifat seçin"
        :show-checked-strategy="SHOW_PARENT"
        :disabled="!(user && user.structure && user.structure.name === 'AMIS')"
      >
        <a-tree-select-node
          v-for="cat in categories"
          :key="cat.uuid"
          :value="cat.uuid"
          :title="cat.name"
        >
          <a-tree-select-node
            v-for="subcat in cat.subCategories"
            :key="subcat.uuid"
            :value="subcat.uuid"
            :title="subcat.name"
          >
            <a-tree-select-node
              v-for="ssubcat in subcat.subCategories"
              :key="ssubcat.uuid"
              :value="ssubcat.uuid"
              :title="ssubcat.name"
            >
            </a-tree-select-node>
          </a-tree-select-node>
        </a-tree-select-node>
      </a-tree-select>
    </div>-->

    <div
      v-if="
        detOffice.selectedAction &&
        (detOffice.selectedAction.selectSubOffice === 'REQUIRED' ||
          detOffice.selectedAction.selectSubOffice === 'OPTIONAL') &&
        (detOffice.selectedAction.dataRequirementStatus === 'NECESSARIES' ||
          detOffice.selectedAction.dataRequirementStatus === 'ALL')
      "
      style="margin-bottom: 10px"
    >
      <p :class="detOffice.selectedAction.selectSubOffice">Tabeli qurum</p>
      <a-select
      
        allowClear
        v-model="detOffice.selectedOfficeId"
        placeholder="Zəhmət olmasa Tabeli qurum seçin"
        @change="(e) => handleSubOfficeChange(e, detOffice)"
        show-search
        :filter-option="false"
        @search="handleSubOfficeSearch"
      >
        <a-select-option v-for="x in filterSubOffices" :key="x.id">{{
          x.name
        }}</a-select-option>
      </a-select>
    </div>



<!-- rey veren  -->

 <div
      v-if="
        detOffice.selectedAction &&
        (detOffice.selectedAction.selectSubOffice === 'REQUIRED' ||
          detOffice.selectedAction.selectSubOffice === 'OPTIONAL') &&
        (detOffice.selectedAction.dataRequirementStatus === 'NECESSARIES' ||
          detOffice.selectedAction.dataRequirementStatus === 'ALL')
      "
      style="margin-bottom: 10px"
    >
      <p >Rəy verən tabeli qurum</p>
      <a-select
        mode="multiple"
        allowClear
        placeholder="Zəhmət olmasa Rəy verən tabeli seçin"
        @change="(e) => handleAssiginForComment(e, detOffice)"
        show-search
        :filter-option="false"
        @search="handleSubOfficeSearch"
      >
        <a-select-option v-for="x in filterSubOffices" :key="x.id">{{
          x.name
        }}</a-select-option>
      </a-select>
    </div>




    <div
      v-if="privilege.workWithFeedbackResult"
      style="margin-bottom: 15px; margin-top: 15px"
    >
      <div v-if="detOffice.assestments.length > 0">
        <a-row
          v-for="(assestment, index) in detOffice.assestments"
          :key="index"
          :style="{
            borderBottom: '1px solid lightgray',
            marginBottom: '15px',
            paddingBottom: '5px',
            flexWrap: 'wrap',
          }"
        >
        <h3 style="text-align:center"  v-if="assestment.startAgain">Vətəndaş təkrar müraciət etmək istəyir.</h3>
          <a-col span="12" :style="{ marginBottom: '10px' }">
            {{
              `
                  ${assestment.citizen.firstName} 
                  ${assestment.citizen.lastName} 
                  ${assestment.citizen.fatherName}
                `
            }}
          </a-col>

          <a-col span="12" :style="{ marginBottom: '10px' }">
            {{ assestment.rate }}
            <a-rate
              v-model="assestment.score"
              :count="3"
              :allowClear="false"
              disabled
            />
          </a-col>

          <a-col
            span="8"
            :style="{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }"
          >
            <a-tooltip v-if="assestment.note" :title="assestment.note">
              <a-icon type="message" />
            </a-tooltip>
          </a-col>

          <a-col
            span="8"
            :style="{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }"
          >
          
            <a-button
              v-if="assestment.files && assestment.files.length > 0"
              size="small"
              @click="showMediaFiles(assestment.files, detOffice)"
            >
              Media fayllar
            </a-button>
          </a-col>

          <a-col
            v-if="assestment.startAgain"
            span="8"
            :style="{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }"
          >
         <!--    <a-tooltip title="Yenidən başlanması istənilmişdir">
              <a-icon type="reload" />
            </a-tooltip> -->
          </a-col>
        </a-row>
      </div>
      <div
        v-else
        style=" color: #666666;
          text-align: center;
          border: 1px solid lightgray;
          padding: 8px;
        "
      >
        İcra nəticəsi qiymətləndirilməyib
      </div>
      <div>
        {{ detOffice.assestments.length }}/{{ problem.applicantCount }}
        qiymətləndirilib
      </div>
<!--       <div>
        {{ detOffice.restartCount }} müraciətçi prosesin yenidən başlamasını
        istəyir
      </div> -->

    </div>

    <div
      v-if="
        (privilege.selectExecutor === 'REQUIRED' ||
          privilege.selectExecutor === 'OPTIONAL') &&
        detOffice.selectedAction &&
        detOffice.selectedAction.dataRequired
      "
    >
      <p style="float: left" :class="privilege.selectExecutor">Birbaşa icraçı</p>
      <a-select
        v-model="detOffice.selectedExecutorUUID"
        placeholder="Zəhmət olmasa icraçı seçin"
        allowClear
        style="margin-bottom: 10px"
      >
        <a-select-option
          v-for="executor in executors"
          :value="executor.uuid"
          :key="executor.uuid"
        >
          {{ executor.firstName + " " + executor.lastName }} -
          {{
            executor.mobilePhoneNumber
              ? executor.mobilePhoneNumber
              : "nömrə yoxdur"
          }}
          ({{ executor.taskCount + " tapşırıq)" }}
        </a-select-option>
      </a-select>
    </div>

    <div
      v-if="
        (privilege.selectExecutor === 'REQUIRED' ||
          privilege.selectExecutor === 'OPTIONAL') &&
        detOffice.selectedAction &&
        detOffice.selectedAction.dataRequired
      "
      style="margin-bottom: 10px"
    >
  
      <p :class="(detOffice.selectedExecutorUUID?'REQUIRED':privilege.selectExecutor)">İcra müddəti</p>
      <a-date-picker
 
        :format="showDatetimeFormat"
        :disabledDate="disabledDate"
        :showTime="true"
        placeholder="İcranın son tarixini seçin"
        v-model="detOffice.executeLastDate"
        :locale="dpLocale"
      />
    </div>

    <div
      v-if="
        detOffice.selectedAction &&
        detOffice.selectedAction.sendExecutorResponse
      "
      style=" margin-bottom: 10px;
        position: relative;
        border: 1px solid lightgray;
        corner-radius: 10px;
        padding: 10px;
      "
    >
      <!--       <a-checkbox :checked="sendRespToCit" @change="handleRespChange"
        >Müraciət edən şəxsə icra nəticəsi göndər</a-checkbox
      > -->
      <h3>Müraciət edən şəxsə icra nəticəsi göndər</h3>
      <div v-if="detOffice.results && detOffice.results.length > 0">
        <div v-if="detOffice.results[0].text">
          <p>İcraçının qeydi</p>
          <a-alert :message="detOffice.results[0].text" type="success" />
        </div>

        <div style="padding: 5px; margin: 4px">
          {{ selectedFiles ? selectedFiles.length : 0 }} fayl seçilib
          <a-button
            style="
              position: right;
              background-color: #fff;
              color: black;
              border-radius: 5px;
            "
            size="small"
            @click="openFilesToChoose(detOffice)"
            >İcra nəticəsi faylı</a-button
          >
          
        </div>
      </div>

      <div style="margin-bottom: 10px">
        <p class="REQUIRED">Qeyd</p>
        <a-textarea
        
        rows="3"
      
          v-model="detOffice.resultText"
        ></a-textarea>
      </div>

<!--      <div style="margin-bottom: 10px">
            <p
        :class="{
          REQUIRED:true,
        }"
      >
        İcra nəticəsi barədə fayllar
      </p> -->
      <div style="margin-bottom: 10px">
        <p :class="detOffice.results.length<1?'REQUIRED':''">İcra nəticəsi barədə fayllar</p>
        <my-file-upload
          ref="fileUploadCR"
          :filesList="detOffice.citRespFiles"
          :pkey="'detOffice-cr' + indice"
          :max="5"
          @upload-change="
            (f) => {
              handleCRUploadChange(f, detOffice);
            }
          "
        ></my-file-upload>
      </div>
    </div>

<!-- it updated after came request -->
    <div style="margin-bottom: 10px"  v-if="!detOffice.selectedAction || detOffice.selectedAction &&
                                            !detOffice.selectedAction.sendExecutorResponse">
      <p
        :class="{
          REQUIRED:
            detOffice.selectedAction && detOffice.selectedAction.askReason||required_Text,
        }"
      >
        Qeyd
      </p>
      <a-textarea
     
        :autoSize="{ minRows: 2, maxRows: 6 }"
        v-model="detOffice.noteField"
      ></a-textarea>
    </div>

    <div style="margin-bottom: 10px" v-if="!detOffice.selectedAction || detOffice.selectedAction &&
                                            !detOffice.selectedAction.sendExecutorResponse">
                                           
      <p  :class="{
          REQUIRED:
            (detOffice.selectedAction && detOffice.selectedAction.fileRequired)||(detOffice.selectedAction&&detOffice.selectedAction.name==='Təmin olunub'&& detOffice.results&& detOffice.results.length<1),
        }"  >Fayllar</p>
      <my-file-upload
        ref="fileUpload"
        :filesList="detOffice.fileList"
        :pkey="'detOffice' + indice"
        :max="5"
        @upload-change="
          (f) => {
            handleUploadChange(f, detOffice);
          }
        "
        @delete-file="(f)=>{
          handleDeleteFile(f,detailOffice)
        }"
      ></my-file-upload>
    
    </div>

    <!--     <div v-if="!oneConfirmButton" class="actions-container">
      <a-button
        v-for="button in detOffice.buttons"
        :key="button.id"
        :class="button.color"
        @click="submit(button, detOffice, index)"
        :style="{ backgroundColor: button.color }"
        :disabled="button.disabled"
      >
        {{ button.name }}
      </a-button>
    </div> -->
    <div v-if="oneConfirmButton" class="actions-container">
      <a-button type="primary" @click="addDetOffice(detOffice)"
        >Əlavə et</a-button
      >
     
    </div>
    <div v-else class="actions-container">
      <a-button
        type="primary"
        @click="submit(detOffice.selectedAction, detOffice, indice)"
        >Saxla</a-button
      >
    </div>

    <!--media dialog-->
    <!-- to show files  -->
    <a-modal
      title="Fayllar"
      v-model="mediadialogVisibility"
      :footer="null"
      :width="980"
      centered
    >
      <conditional-media
        :multipleSelection="false"
        :filesList="files"
        @change="handleFilesSelect"
        :differentSelectedType="true"
      ></conditional-media>
    </a-modal>

    <!--media dialog-->
    <!-- to choose files -->
    <a-modal
      title="Fayllar"
      v-model="chooseMediaVis"
      okText="Təsdiq"
      cancelText="İmtina"
      @cancel="
        (e) => {
          this.selectedFiles = [];
        }
      "
      @ok="(e) => (chooseMediaVis = false)"
      :width="980"
      centered
    >
      <conditional-media
        :multipleSelection="true"
        :filesList="files"
        @change="handleFilesSelect"
        :differentSelectedType="true"
      ></conditional-media>
    </a-modal>
  </a-card>
</template>

<script>
import MyFileUpload from "@/components/partials/MyFileUpload/index";
import mixin from "@/mixins/index";
import ConditionalMedia from "@/components/partials/ConditionalMedia/index";
import moment from "moment";
import { URL, apiCall } from "@/utils/api";
import { TreeSelect } from "ant-design-vue";
import { tr } from 'date-fns/locale';
import axios from "axios";
const SHOW_PARENT = TreeSelect.SHOW_PARENT;

export default {
  props: {
    selectedPOffice: Object,
    initialOffice: Object,
    problem: Object,
    detOffice: Object,
    privilege: Object,
    noExecutorWarning: Boolean,
    indice: Number,
    structures: Array,
    oneConfirmButton: Boolean,
    required_Text:Boolean,
  },
  components: {
    "my-file-upload": MyFileUpload,
    "conditional-media": ConditionalMedia,
  },
  mixins: [mixin],
  data() {
  
    return {
      showCategorySelect:false,
      chooseMediaVis: false,
      filteredOffices: [],
      allOffices: [],
      files: [],
      mediadialogVisibility: false,
      SHOW_PARENT,
      categories: [],
      filterSubOffices: [],
      executors: [],
      sendRespToCit: false,
      selectedFiles:[],
      forComment:[]
    };
  },
  created() {


    if (!this.detOffice.selectedExecutorUUID)
      this.$set(this.detOffice, "selectedExecutorUUID", null);
    if (!this.detOffice.executeLastDate)
      this.$set(this.detOffice, "executeLastDate", null);
    if (
      (this.privilege.selectSubOffice === "REQUIRED" ||
        this.privilege.selectSubOffice === "OPTIONAL") &&
      this.detOffice.problemSubOffices&& this.detOffice.problemSubOffices.length>0
    )
      this.$set(this.detOffice, "selectedOfficeId", this.detOffice.problemSubOffices[0].office.id);
    if (this.detOffice.id)
      this.getActions(this.problem.id, this.detOffice.id).then((response) => {
        this.$set(this.detOffice, "buttons", response.data.data);
        this.$set(
          this.detOffice,
          "selectedAction",
          this.detOffice.buttons.length === 1 ? this.detOffice.buttons[0] : null
        );
        this.$set(
          this.detOffice,
          "selectedKey",
          this.detOffice.buttons.length === 1
            ? this.detOffice.buttons[0].id
            : null
        );
      });
    let initialIds = this.structures
      ? this.structures.map((item) => item.id)
      : [];

    if (
      this.privilege.selectParentOffice == "REQUIRED" ||
      this.privilege.selectParentOffice == "OPTIONAL"
    ) {
      this.getExecutorStructures().then((response) => {
        if (!response.data.error) {
          this.allOffices = response.data.data.entities;
       /*    this.allOffices = this.allOffices.filter(
            (item) => (this.initialOffice && this.initialOffice.id==item.id)|| initialIds.indexOf(item.id) === -1
          ) */;
          this.offices = this.allOffices;
          this.filteredOffices = this.offices;
          console.log(this.selectedPOffice,'dgdfgdfgdf');
          if (this.selectedPOffice) {
            
            this.filteredOffices = [this.selectedPOffice];
            this.$set(
              this.detOffice,
              "selectedParentOfficeId",
              this.selectedPOffice.id
            );
          }
        }
      });
    }

    if (
      this.privilege.selectSubOffice === "REQUIRED" ||
      this.privilege.selectSubOffice === "OPTIONAL"
    ) {
      this.getSubExecStructures().then((response) => {
        if (!response.data.error) {
          this.subOffices = response.data.data.entities;
          this.filterSubOffices = this.subOffices;
        }
      });
    }
    this.getExecutors();
    
    this.getCategories().then((response) => {
      if (!response.data.error) {
        this.categories = response.data.data.entities;
      }
    });



     this.detOffice.resultText =
        this.detOffice.results && this.detOffice?.results?.length > 0
          ? this.detOffice.results[0].text
          : "";
  },
  watch: {
    selectedPOffice: function () {
      if (this.selectedPOffice) {
        this.filteredOffices = [this.selectedPOffice];
        this.$set(
          this.detOffice,
          "selectedParentOfficeId",
          this.selectedPOffice.id
        );
      }
    },
  },
  methods: {
    handleCatChange(e){
       this.$set(this.detOffice,'selectedCategoryUUID',e);
    },
    handleSubOfficeChange(key, officeDetail) {
      officeDetail.selectedOfficeId = key;
      this.handleSubOfficeSearch("");
    },
    handleAssiginForComment(key){
         this.forComment = key.map(item=>{
           return {id:item}
         })
      this.handleSubOfficeSearch("");
      console.log(this.forComment,'sdfdsf')
    },
    handleFilesSelect(filesList) {
      this.selectedFiles = filesList;
    },
    openFilesToChoose(detailOffice) {
      if (detailOffice.results && detailOffice.results.length > 0) {
        this.files = detailOffice.results[0].files;
        this.chooseMediaVis = true;
      }
    },

    handleCRUploadChange(fileList, officeDetail) {
      officeDetail.citRespFiles = fileList;
    },
    handleRespChange(e) {
      this.sendRespToCit = e.target.checked;
    },

    handleButtonChange(e, officeDetail) {
      this.$set(
        officeDetail,
        "selectedAction",
        officeDetail.buttons.find(
          (item) => item.id === officeDetail.selectedKey
        )
      );
    },
    handleUploadChange(fileList, officeDetail) {
  
      officeDetail.fileList = fileList;
      console.log(officeDetail,'tttttttt');
    },
    handleDeleteFile(fileList,officeDetail){
      officeDetail.fileList = fileList;
    },
    addDetOffice(officeDetail) {
      if (!officeDetail.selectedParentOfficeId) {
        this.$message.error("Qurum mütləq seçilməlidir.");
        return;
      }
      if (!officeDetail.noteField||officeDetail.noteField.trim()?.length==0) {
         this.$message.error("Qeyd mütləq daxil edilməlidir.");
        return;
      }
      const problem = this.problem;
      const message = this.$message;
      const destroyAll = this.$destroyAll;
      console.log(officeDetail,'testv2');
      this.$confirm({
        title: "Əlavə edilsin?  ",
        okText: "Bəli ",
        cancelText: "Xeyr",
        okType: "primary",
        onOk() {
          console.log(officeDetail.fileList,'llllllllll');
          return new Promise((resolve, reject) => {
            apiCall({
              url:
                URL[process.env.NODE_ENV].service_api +
                `problems/${problem.id}/execStructures`,
              method: "POST",
              data: {
                url:
                  window.location.pathname.split("/").length === 0
                    ? ""
                    : window.location.pathname.split("/")[1],
                note: officeDetail.noteField,
                execStructureId: officeDetail.parentOffice?officeDetail.parentOffice.id:officeDetail.selectedParentOfficeId,
                files: officeDetail.fileList,
              },
            })
              .then((response) => {
                if (!response.data.error) {
                  message.success("Qurum əlavə edildi. ");
                  setInterval(() => {
                    location.reload();
                  }, 1000);
                } else message.error(response.data.error.message);
              })
              .catch((err) => {
                message.error("Xəta baş verdi");
                console.log(err);
                destroyAll();
              });
          }).catch((err) => console.log(err));
        },
        onCancel() {
          // console.log("Cancel");
        },
      });
    },
    submit(button, detailOffice, index) {
      console.log(this.files,'lllll');
   /*    console.log(detailOffice,'button'); */
   if (button.name==='Təmin olunub'&&!detailOffice.citRespFiles) {
    
    if (this.detOffice.results.length <1&&(detailOffice.fileList?.length<1)) {
      console.log(detailOffice.fileList,'test');
      return  this.$message.error("Fayl mütləq seçilməlidir. ");
    }
    else if(this.selectedFiles?.length<1&&(detailOffice.fileList?.length<1)){
      return  this.$message.error("İcra nəticəsi faylı mütləq seçilməlidir. ");
    }
   }
    

 
      if (!button) {
        this.$message.error("Əməliyyat mütləq seçilməlidir. ");
        return;
      }
      if (
        (this.privilege.selectParentOffice === "REQUIRED" ||
          this.privilege.selectParentOffice === "OPTIONAL") &&
        button.dataRequired &&
        !detailOffice.selectedParentOfficeId &&
        !detailOffice.parentOffice &&
        detailOffice.isNew
      ) {
        this.$message.error("Qurum mütləq seçilməlidir.");
        return;
      }
      if (
        button.selectSubOffice === "REQUIRED" &&
        (button.dataRequirementStatus === "NECESSARIES" ||
          button.dataRequirementStatus === "ALL") &&
        !detailOffice.selectedOfficeId
      ) {
        this.$message.error("Tabeli qurum mütləq seçilməlidir.");
        return;
      }
      // console.log(detailOffice);
      if (
        this.privilege.selectCategory === "REQUIRED" &&
        (button.dataRequirementStatus === "NECESSARIES" ||
          button.dataRequirementStatus === "ALL") &&
        !detailOffice.selectedCategoryUUID
      ) {
        this.$message.error("Təsnifat mütləq seçilməlidir.");
        return;
      }
      if (
        this.privilege.selectExecutor === "REQUIRED" &&
        button.dataRequired &&
        !detailOffice.selectedExecutorUUID
      ) {
        this.$message.error("Birbaşa icraçı mütləq seçilməlidir.");
        return;
      }
      if (
        this.privilege.selectExecutor === "REQUIRED" &&
        button.dataRequired &&
        !detailOffice.executeLastDate
      ) {
        this.$message.error("Son icra tarixi mütləq seçilməlidir. ");
        return;
      }
      if (
        this.privilege.selectExecutor === "OPTIONAL" &&
        detailOffice.executeLastDate &&
        button.dataRequired &&
        !detailOffice.selectedExecutorUUID
      ) {
        this.$message.error("Birbaşa icraçı mütləq seçilməlidir.");
        return;
      }
      if (
        this.privilege.selectExecutor === "OPTIONAL" &&
        detailOffice.selectedExecutorUUID &&
        button.dataRequired &&
        !detailOffice.executeLastDate
      ) {
        this.$message.error("Son icra tarixi mütləq seçilməlidir. ");
        return;
      }
      /* if (
        button.selectParentOffice === "REQUIRED" &&
        (button.dataRequirementStatus === "NECESSARIES" ||
          button.dataRequirementStatus === "ALL") &&
        !detailOffice.selectedOfficeId
      ) {
        this.$message.error("İcraçı təşkilat seçilməyib");
        return;
      } */
      if (
        button.askReason &&
        (!detailOffice.noteField || detailOffice.noteField.trim().length == 0)
      ) {
        this.$message.error("Qeyd mütləq daxil edilməlidir.");
        return;
      }
        if(button.fileRequired&&this.detOffice.fileList.length<1) {
          this.$message.error('İcra nəticəsi ilə bağlı fayl mütləq əlavə edilməlidir.');return;}
      let _result;
      if (button.sendExecutorResponse) {
        if ( detailOffice?.resultText==null||
          detailOffice?.resultText == "" || detailOffice.resultText?.length<2&&
          (citRespFilesForResult == null || citRespFilesForResult == []) &&
          (selectedFilesForResult == null || selectedFilesForResult == [])
        ) {
          this.$message.error("İcra nəticəsi ilə bağlı qeyd mütləq əlavə edilməlidir.");
          return;
        }
         
        const citRespFilesForResult = detailOffice.citRespFiles || [];
        const selectedFilesForResult = ()=> {
          if (Array.isArray(this.selectedFiles)) {
           return  this.selectedFiles || [];
          }else{
            console.log( [this.selectedFiles]||[]);
           return  [this.selectedFiles]||[]
          }
          
          
        }
    console.log(selectedFilesForResult());
        _result = {
          text: detailOffice.resultText,
          files: [...selectedFilesForResult(), ...citRespFilesForResult],
        };
          console.log('test');
      }
        
console.log({
        button: button,
        detailOffice: detailOffice,
        result: _result,
      });
      this.$emit("submit", {
        button: button,
        detailOffice: detailOffice,
        commentarStructures:this.forComment,
        result: _result,
      });
    },
    async handleOfficeChange (key, officeDetail) {
      if (
        this.privilege.selectParentOffice === "REQUIRED" ||
        this.privilege.selectParentOffice === "OPTIONAL"
      ) {
        let selectedExecStructure = this.filteredOffices.find(item=>item.id == key);

        if(selectedExecStructure && selectedExecStructure.categorySelectionRequired){
          this.showCategorySelect =true;
        const res = await axios.get(
          `${URL[process.env.NODE_ENV].auth_api}categories/byStructure/${selectedExecStructure.id}`);
          this.categories =res.data.data.entities
          console.log(res.data.data.entities);
        }

        let tmp = this.problem.execStructures.find((item) =>
          item.parentOffice ? item.parentOffice.id === key : false
        );
        
      

        if (tmp) {
          this.$set(officeDetail, "selectedOfficeId", null);
          this.$set(officeDetail, "parentOffice", null);
          this.$message.error("Bu orqan artıq əlavə edilib");
        } else officeDetail.parentOffice = { id: key };
      }

      this.handleOfficeSearch("");
    },
    showMedia(officeDetail) {
      this.files = officeDetail.lastOperation.files;
      if (!this.files || this.files.length === 0) {
        this.$message.warning("Media fayl yoxdur");
        return;
      }
      this.mediadialogVisibility = true;
    },
    showMediaFiles(files, detOffice) {
      this.detOfficeOpened = detOffice;
      console.log(files,'files');
      this.files = files;
      this.mediadialogVisibility = true;
    },
    handleSubOfficeSearch(value) {
      const regex = new RegExp(value, "i");
      this.filterSubOffices = this.subOffices.filter((office) =>
        regex.test(office.name.toLowerCase())
      );
    },
    handleOfficeSearch(value) {
      const regex = new RegExp(value, "i");
      this.filteredOffices = this.offices.filter((office) =>
        regex.test(office.name.toLowerCase())
      );
    },

    disabledDate(current) {
      return (
        current < moment() &&
        (current.date() !== moment().date() ||
          current.month() !== moment().month() ||
          current.year() !== moment().year())
      );
    },

    saveParentOffice(officeDetail) {
      if (!officeDetail.selectedParentOfficeId) {
        this.$message.error("Qurum mütləq seçilməlidir.");
        return;
      }
      const problem = this.problem;
      const message = this.$message;
      const destroyAll = this.$destroyAll;
      this.$confirm({
        title: "Əlavə edilsin?  ",
        okText: "Bəli ",
        cancelText: "Xeyr",
        okType: "primary",
        onOk() {
          return new Promise((resolve, reject) => {
            apiCall({
              url:
                URL[process.env.NODE_ENV].service_api +
                `problems/${problem.id}/execStructures`,
              method: "POST",
              data: {
                url:
                  window.location.pathname.split("/").length === 0
                    ? ""
                    : window.location.pathname.split("/")[1],
                note: officeDetail.noteField,
                execStructureId: officeDetail.parentOffice.id,
                files: officeDetail.fileList,
              },
            })
              .then((response) => {
                if (!response.data.error) {
                  message.success("Qurum əlavə edildi. ");
                  setInterval(() => {
                    location.reload();
                  }, 1000);
                } else message.error(response.data.error.message);
              })
              .catch((err) => {
                message.error("Xəta baş verdi");
                console.log(err);
                destroyAll();
              });
          }).catch((err) => console.log(err));
        },
        onCancel() {
          
          // console.log("Cancel");
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped src="./OperationDetail/index.scss"></style>